export default {"src":"/_next/static/media/retaining-wall.fdb84206.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};